module.exports = __webpack_public_path__ + "img/taiwan-drama.de2230f3.jpg";